import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";
import loginRoutes from "./router/LoginRoutes";
import newThemeLoginRoutes from "./router/newthemeLoginRoutes";
import indexRoutes from "./router/indexroutes";
import { useIdleTimer } from "react-idle-timer";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import OfflineDb from "./db";
import GlobalSpinnerContextProvider from "./context/GlobalSpinnerContext";
import GlobalSpinner from "./component/GlobalSpinner/GlobalSpinner";
import { setLoginUser } from "./redux/actions/action";
import { Configuration } from "./assets/data/config";
const loading = <div className="loading"></div>;

const App = ({ setLoginUser, storeIsLogin }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.body.classList.remove(document.body.classList[0]);
    Configuration.theme.name == "Template1"
      ? document.body.classList.add("theme_blue")
      : document.body.classList.add("theme_red");
    OfflineDb.getDataFromPouchDB("loginDetails").then((doc) => {
      if (doc.status == 404 && loggedIn) {
        setLoggedIn(false);
      }
    });
  }, [storeIsLogin]);
  const handleOnIdle = (event) => {
    if (loggedIn && navigator.onLine) {
      OfflineDb.getAllEntities().then((res) => {
        if (res == undefined || res.total_rows == 0) {
          localStorage.clear();
          OfflineDb.deleteDatabse()
            .then((res) => {
              setLoginUser(false);
            })
            .catch((err) => {
              setLoginUser(false);
            });
        } else {
          swal({
            title: t("Offline data"),
            text: t("Offline records found, please sync data before logout"),
            icon: "warning",
            buttons: "Close",
          });
        }
      });
    }
  };
  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 10,
    onIdle: handleOnIdle,
    // onActive: handleOnActive,
    // onAction: handleOnAction,
    // debounce: 500
  });
  OfflineDb.setPouchDBDatabase();

  const updateLoggedInStatus = () => {
    setLoggedIn(true);
    setLoginUser(true);
  };

  const aIndexRoutes = indexRoutes.map((prop, key) => {
    // if (prop.redirect) {
    //   return <Redirect from={prop.path} to={prop.to} key={key} />;
    // }
    return <Route to={prop.path} component={prop.component} key={key} />;
  });
  const aLoginRoutes = loginRoutes.map((prop, key) => {
    if (prop.redirect) {
      return <Redirect from={prop.path} to={prop.to} key={key} />;
    }
    return (
      <Route
        path={prop.path}
        key={key}
        render={(e) => <prop.component onSuccess={updateLoggedInStatus} />}
      />
    );
  });
  const aNewThemeLoginRoutes = newThemeLoginRoutes.map((prop, key) => {
    if (prop.redirect) {
      return <Redirect from={prop.path} to={prop.to} key={key} />;
    }
    return (
      <Route
        path={prop.path}
        key={key}
        render={(e) => <prop.component onSuccess={updateLoggedInStatus} />}
      />
    );
  });

  return (
    <GlobalSpinnerContextProvider>
      <GlobalSpinner />
      <BrowserRouter basename={window.cordova ? "/" : "/cdic"}>
        <React.Suspense fallback={<div>Loading</div>}>
          <Switch>
            {loggedIn
              ? aIndexRoutes
              : Configuration.theme.name == "Template1"
              ? aLoginRoutes
              : aNewThemeLoginRoutes}
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    </GlobalSpinnerContextProvider>
  );
};

function mapStateToProps(state) {
  const { storeState } = state;
  return { storeIsLogin: storeState.isLoggedIn };
}

export default connect(mapStateToProps, { setLoginUser })(App);

//export default App;
